import React, { useState } from "react";
import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import { Paper } from "@mui/material";
import ZoneSets from "./ZoneSets";
import PriceLists from "./PriceLists";
import SurchargeSets from "./SurchargeSets";

export default function Pricing() {
  const [value, setValue] = useState("1");

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Paper sx={{ height: "100%", margin: 2 }}>
      <Box sx={{ width: "100%", typography: "body1" }}>
        <TabContext value={value}>
          <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
            <TabList onChange={handleChange} aria-label="lab API tabs example">
              <Tab label="Zone Sets" value="1" />
              <Tab label="Price Lists" value="2" />
              <Tab label="Surcharge Sets" value="3" />
            </TabList>
          </Box>
          <TabPanel value="1">
            <ZoneSets />
          </TabPanel>
          <TabPanel value="2">
            <PriceLists />
          </TabPanel>
          <TabPanel value="3">
            <SurchargeSets />
          </TabPanel>
        </TabContext>
      </Box>
    </Paper>
  );
}
